<!-- =========================================================================================
     File Name: meal/Main.vue
     Description: meal-Main Page
     ========================================================================================== -->

<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter justify-center items-center">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-2/5 m-4">
            <vx-card>
                <div class="vx-card__title mb-6">
                    <h4 class="text-center">환자 식사관리</h4>
                </div>

                <img src="@/assets/images/pages/logo.png" alt="coming-soon" class="mx-auto mb-2" width="150" />

                <vs-divider position="center">검색</vs-divider>

                <div class="subscription">
                    <span class="mb-5"> 이름을 입력해주세요.</span>
                    <vs-input type="text" label-placeholder="환자명 입력" v-model="username" class="w-full mb-4" v-on:keyup.enter="userSearch" size="large" />
                    <p v-if="usernameCheck == true" class="text-danger mb-4">{{ userCheckMsg }}</p>
                </div>
                <div class="subscription">
                    <span class="mb-5"> 생년월일을 선택해주세요.</span>
                    <!-- <date-picker name="patientBirthday" v-model="patientBirthday" :locale="'ko'" valueType="format" class="vs-inputx normal w-full"></date-picker> -->
                    <vs-input class="w-full" name="" label="생년월일" placeholder="형식: 1980-01-01" v-model="patientBirthday" />
                </div>
                <div class="mt-5">
                    <vs-button class="w-full" @click="userSearch" ref="username">검색</vs-button>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import axiosClass from '@/../util/axiosClass';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    components: {
        DatePicker,
    },
    data() {
        return {
            username: '',
            usernameCheck: false,
            userCheckMsg: '',
            patientBirthday: '',
            uid: '',
        };
    },
    methods: {
        /** 식사관리 - 환자검색 */
        async userSearch() {
            const jsonData = {
                search_username: this.username,
                patientBirthday: this.patientBirthday,
            };
            this.usernameCheck = false;
            if (this.username == false) {
                this.usernameCheck = true;
                this.userCheckMsg = '검색할 이름을 입력해주세요.';
                return;
            }
            console.log(jsonData);
            const { data } = await axiosClass.get('/api/patient/patientInfo/meal', jsonData, true);
            console.log(data.data[0].PATIENT_UID);

            this.uid = data.data[0].PATIENT_UID;
            // console.log(this.uid);
            if (data.data.length == undefined || data.data.length == 0) {
                this.usernameCheck = true;
                this.userCheckMsg = '검색한 이름의 환자(생년월일) 또는 보호자가 존재하지 않습니다.재확인 후 검색해주세요.';
                this.username = '';
                this.patientBirthday = '';
            } else {
                location.href = '../meal/DetailView/' + this.uid;
            }
        },
    },
};
</script>
